import { useDispatch, useSelector } from 'react-redux';

import { RootDispatch, RootState } from 'storage/store';
import { Constant, StatusCode } from 'utils/consts';
import { Url } from 'utils/urls';
import {
  AlternativeLoginMessages,
  MessageTypes,
  UserCredentials,
  UserLoginResponse
} from 'storage/user/user.model';

import { onLoginFormSubmitType } from '../Login';

const useLoginViaEmail = <T extends UserCredentials>() => {
  const dispatch = useDispatch<RootDispatch>();
  const { clientSynchroToggle } = useSelector(
    (state: RootState) => state.application
  );
  const onSubmit: onLoginFormSubmitType<T> = async (values, helpers) => {
    const { login, password } = values;
    const { resetForm } = helpers;
    const isAlternativeEmailLogin =
      window.location.pathname === Url.loginEmailUgodowi;
    const isCredentialsInvalid =
      password.length >= Constant.oneThousandTwentyFour ||
      login.length >= Constant.seventy;
    const reducerActionName = isAlternativeEmailLogin
      ? 'changeKisaUserStatus'
      : 'changeUserStatus';

    const badCredentials = () => {
      resetForm({ values: { ...values, password: '' } });
      const message = isAlternativeEmailLogin
        ? AlternativeLoginMessages.badCredentials
        : MessageTypes.invalidPassword;
      dispatch.user[reducerActionName](message);
    };

    if (isCredentialsInvalid) {
      badCredentials();
      return;
    }

    const { status, message, success } = (await dispatch.user.loginUser(
      values
    )) as UserLoginResponse;

    const isRegulationsAcceptanceRequired =
      status === StatusCode.forbiddenCode &&
      message === MessageTypes.regulationsNotAccepted;

    if (status === StatusCode.unauthorizedCode) {
      badCredentials();
      return;
    }
    if (
      clientSynchroToggle &&
      status === StatusCode.forbiddenCode &&
      message?.includes(MessageTypes.notSynced)
    ) {
      dispatch.user[reducerActionName](MessageTypes.notSynced);
      return;
    }
    if (isRegulationsAcceptanceRequired) {
      dispatch.user.changeRegulationsAcceptanceRequired(true);
      return;
    }
    if (!success && message) {
      dispatch.user[reducerActionName](message);
    }
  };

  return { onSubmit };
};

export default useLoginViaEmail;
